import React from "react";
import "../../sass/ui/input.scss"; 

export const Input = (props) => <input className="custom-input" {...props} />;